import type { RefObject } from 'react'

interface LockupProps {
  /** Slowly rotate the ring of ticks. The W stays upright. */
  spin?: boolean
  /** Lets the login form measure where the R of WONDER ends. */
  wonderRef?: RefObject<HTMLSpanElement>
}

/**
 * The full WonderWorks lockup: the mark plus the wordmark.
 *
 * The mark is two files rather than one so the ring can rotate on its own —
 * spinning the whole logo would tip the W over with it. They share a viewBox,
 * so stacking them reproduces the original exactly.
 *
 * The wordmark is live text in Aptos (WONDER bold, WORKS light) rather than
 * artwork, so it stays crisp and selectable — and so the login form can measure
 * where the R of WONDER actually lands and line its own right edge up with it.
 *
 * Sizing comes from the --lockup-mark custom property on an ancestor, so the
 * whole lockup scales as one thing.
 */
export function Lockup({ spin = true, wonderRef }: LockupProps) {
  return (
    <div className="lockup" role="img" aria-label="WonderWorks">
      <span className="lockup__mark">
        <img
          className={`lockup__ring${spin ? ' lockup__ring--spin' : ''}`}
          src="/brand/logo-ring.svg"
          alt=""
          aria-hidden="true"
        />
        <img className="lockup__w" src="/brand/logo-mark.svg" alt="" aria-hidden="true" />
      </span>
      <span className="lockup__word">
        <span className="lockup__wonder" ref={wonderRef}>WONDER</span>
        <span className="lockup__works">WORKS</span>
      </span>
    </div>
  )
}
